import React, { useState } from "react";
import { Tabs, Tab, Card, CardBody, CardHeader } from "@nextui-org/react";
import ButtonRequire from "../Button/ButtonRequire";
import MailIcon from "../../assets/icons/mail-01.svg";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow.svg";
import WhatsappIcon from "../../assets/icons/whatsapp.svg";
import PassIcon from "../../assets/icons/passcode.svg";
import Button from "../Button/Button";
import InputIcon from "../Input/InputIcon";
import Countdown from "../Countdown";
import InputOtp from "../Input/InputOtp";
import { isValidPhoneNumber } from "../../utils/Utils";
import { useTranslation } from "react-i18next";

export default function App({
  setEmail,
  isSent,
  Signin,
  isValidEmail,
  setSelected,
  whatsappNum,
  setWhatsappNum,
  selected,
  email,
  counter,
  ConfirmOTP,
  isLoading,
  setErrorMsg,
  errorMsg,
  setOtp,
  otp,
  setCounter,
}) {
  const [active, setActive] = useState(false);
  const { t } = useTranslation();
  let tabs = [
    {
      id: "email",
      label: "Email",
      icon: MailIcon,
      content: (
        <form>
          <div
            className={`${isSent ? "max-h-48" : errorMsg.email.length > 0 ? "max-h-20" : "max-h-12"}  transition-max-height space-y-4 delay-100 duration-150 ease-in-out`}
          >
            <div>
              <InputIcon
                icon={MailIcon}
                isInvalid={errorMsg.email.length > 0}
                value={email}
                onFocus={() => setErrorMsg({ ...errorMsg, email: "" })}
                placeholder={t("signin.emailPlaceholder")}
                onChange={(e) => setEmail(e.target.value)}
              />

              {errorMsg.email.length > 0 && (
                <div className="mt-1 text-2xs text-danger">
                  {errorMsg.email}
                </div>
              )}
            </div>
            <div
              className={`${isSent ? "visible delay-300 duration-500" : "invisible"} z-10 transition-transform`}
            >
              <InputOtp
                icon={PassIcon}
                placeholder={t("signin.otpPlaceholder")}
                value={otp}
                onChange={(value) => setOtp(value)}
              />

              <div className="mt-1 flex justify-between text-2xs">
                <p>{t("signin.otpInstruction")} Email</p>
                {counter > 0 ? (
                  <Countdown value={counter} onFinish={() => setCounter(0)} />
                ) : (
                  <button onClick={Signin} className="text-blue-500">
                    {t("signin.resend")}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="z-50 mt-4 flex flex-col space-y-2">
            <Button
              label={`${isSent ? t("signin.submit") : `${t("signin.continue")} Email`}`}
              variant="gradient"
              withIcon={<ArrowIcon className="text-monochrome-0" />}
              onClick={isSent ? ConfirmOTP : Signin}
              disabled={
                (isSent ? otp.length < 4 : !isValidEmail(email)) || isLoading
              }
            />
          </div>
        </form>
      ),
    },
    {
      id: "whatsapp",
      label: "WhatsApp",
      icon: WhatsappIcon,
      content: (
        <form>
          <div
            className={`${isSent ? "max-h-48" : errorMsg.email.length > 0 ? "max-h-20" : "max-h-12"}  transition-max-height space-y-4 delay-100 duration-150 ease-in-out`}
          >
            <div>
              <InputIcon
                icon={WhatsappIcon}
                isInvalid={errorMsg.email.length > 0}
                onFocus={() => setErrorMsg({ ...errorMsg, email: "" })}
                prefix="+62"
                type="tel"
                value={whatsappNum}
                placeholder={t("signin.waPlaceholder")}
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/\D/g, "");
                  if (value.startsWith("08")) {
                    value = value.replace(/^08/, "8");
                  } else if (value.startsWith("628")) {
                    value = value.replace(/^628/, "8");
                  }
                  setWhatsappNum(value);
                }}
              />

              {errorMsg.email.length > 0 && (
                <div className="mt-1 text-2xs text-danger">
                  {errorMsg.email}
                </div>
              )}
            </div>
            <div
              className={`${isSent ? "visible delay-300 duration-500" : "invisible"} z-10 transition-transform`}
            >
              <InputOtp
                icon={PassIcon}
                value={otp}
                placeholder={t("signin.otpPlaceholder")}
                onChange={(value) => setOtp(value)}
              />

              <div className="mt-1 flex justify-between text-2xs">
                <p>{t("signin.otpInstruction")} WhatsApp</p>
                {counter > 0 ? (
                  <Countdown value={counter} onFinish={() => setCounter(0)} />
                ) : (
                  <button onClick={Signin} className="text-blue-500">
                    {t("signin.resend")}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="z-50 mt-4 flex flex-col space-y-2">
            <Button
              label={`${isSent ? t("signin.submit") : `${t("signin.continue")} WhatsApp`}`}
              variant="gradient"
              withIcon={<ArrowIcon className="text-monochrome-0" />}
              onClick={isSent ? ConfirmOTP : Signin}
              disabled={
                (isSent ? otp.length < 4 : !isValidPhoneNumber(whatsappNum)) ||
                isLoading
              }
            />
          </div>
        </form>
      ),
    },
  ];

  return (
    <div className="flex w-full flex-col">
      <Tabs
        fullWidth
        size="md"
        aria-label="Tabs form"
        selectedKey={selected}
        onSelectionChange={setSelected}
        items={tabs}
        classNames={{
          tabList: "bg-transparent-black-5 rounded-xl p-1.5",
          cursor: "!bg-monochrome-0 rounded-lg",
          tab: "py-5 text-monochrome-600 font-semibold",
        }}
      >
        {(item) => (
          <Tab
            key={item.id}
            title={
              <div className="flex items-center space-x-2">
                <img src={item.icon} alt="" />
                <span>{item.label}</span>
              </div>
            }
            className="px-0 focus:outline-none"
          >
            <div className="py-2">{item.content}</div>
          </Tab>
        )}
      </Tabs>
    </div>
  );
}
